import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';
import { SiteHeader } from '../components/site-header';
import { SiteFooter } from '../components/site-footer';

const TermsPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col bg-[#E0EAF3]">
      <SiteHeader />
      <Container maxWidth="lg" sx={{ py: 4, flex: 1 }}>
        <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
          Términos y Condiciones
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Bienvenido a JugarHoy
        </Typography>
        
        <Typography variant="body1" paragraph>
          Estos términos y condiciones establecen las reglas y regulaciones para el uso de la aplicación móvil JugarHoy.
        </Typography>

        <Typography variant="body1" paragraph>
          Al acceder y utilizar esta aplicación, asumimos que acepta estos términos y condiciones en su totalidad. 
          No continúe usando la aplicación JugarHoy si no acepta todos los términos y condiciones establecidos en esta página.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          1. Definiciones
        </Typography>
        
        <Typography variant="body1" paragraph>
          Los siguientes términos se aplican a estos Términos y Condiciones, Política de Privacidad y Aviso de Descargo de Responsabilidad:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            <strong>Usuario, Usted y Su</strong> se refiere a usted, la persona que accede a esta aplicación y acepta los términos y condiciones de la Compañía.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>La Compañía, Nosotros, Nuestro y Nos</strong> se refiere a Jugar Hoy!
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Club</strong> se refiere a toda persona física o jurídica que registra y administra un establecimiento deportivo dentro de la plataforma Jugar Hoy!
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Entrenador / Coach</strong> se refiere a toda persona física que registra un perfil de entrenador dentro de la plataforma para ofrecer servicios de coaching deportivo.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Jugador</strong> se refiere al usuario final que realiza reservas o participa en actividades a través de la plataforma.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Cargo por Servicio</strong> se refiere al costo cobrado por Jugar Hoy! al Club o Entrenador por el uso de la plataforma, según el plan contratado.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Plan</strong> se refiere al nivel de servicio contratado por el Club o Entrenador: BÁSICO, PLUS o PREMIUM.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Parte, Partes, o Nosotros</strong> se refiere tanto al Usuario como a nosotros mismos.
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          2. Privacidad y Protección de Datos
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>2.1 Recopilación de Información</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          JugarHoy puede recopilar información sobre jugadores, entrenadores y miembros del club que se proporcione a través de la aplicación. 
          Esta información incluye, pero no se limita a:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">Nombres y apellidos</Typography>
          <Typography component="li" variant="body1">Direcciones de correo electrónico</Typography>
          <Typography component="li" variant="body1">Números de teléfono</Typography>
          <Typography component="li" variant="body1">Información del club y equipo</Typography>
          <Typography component="li" variant="body1">Datos de rendimiento deportivo</Typography>
        </Box>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          <strong>2.2 Privacidad de la Información</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          Toda la información proporcionada a JugarHoy sobre jugadores, entrenadores y miembros del club se mantendrá privada y confidencial 
          hasta que el usuario se registre oficialmente en la aplicación. El registro puede realizarse de las siguientes maneras:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            A través de un enlace de invitación enviado por un miembro existente del club
          </Typography>
          <Typography component="li" variant="body1">
            Utilizando el mismo correo electrónico o número de teléfono verificado que ya existe en el sistema
          </Typography>
        </Box>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          <strong>2.3 Control del Usuario</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          Una vez que un usuario se registre oficialmente, tendrá control total sobre su información y podrá decidir:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Continuar siendo miembro del club y permitir que su información sea visible para otros miembros
          </Typography>
          <Typography component="li" variant="body1">
            Solicitar la eliminación de su información del sistema
          </Typography>
          <Typography component="li" variant="body1">
            Modificar qué información es visible para otros miembros
          </Typography>
        </Box>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          <strong>2.4 Eliminación de Datos y Cumplimiento con Facebook</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          JugarHoy cumple con los requisitos de eliminación de datos de Facebook para aplicaciones que integran 
          servicios de Facebook. De acuerdo con las políticas de Facebook para desarrolladores:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Los usuarios pueden solicitar la eliminación de su cuenta desde su página de perfil en la aplicación
          </Typography>
          <Typography component="li" variant="body1">
            Una vez solicitada la eliminación, la cuenta se desactiva inmediatamente
          </Typography>
          <Typography component="li" variant="body1">
            Toda la información personal del usuario será eliminada permanentemente dentro de los 30 días siguientes a la solicitud
          </Typography>
          <Typography component="li" variant="body1">
            Los clubes también pueden solicitar la eliminación de sus datos desde su panel de administración
          </Typography>
        </Box>
        
        <Typography variant="body1" paragraph>
          Para solicitar la eliminación de su cuenta, los usuarios pueden:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Acceder a su perfil en la aplicación JugarHoy
          </Typography>
          <Typography component="li" variant="body1">
            Navegar a la sección de configuración de cuenta
          </Typography>
          <Typography component="li" variant="body1">
            Seleccionar la opción "Eliminar cuenta"
          </Typography>
          <Typography component="li" variant="body1">
            Confirmar la eliminación de acuerdo con los términos establecidos
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          3. Sistema de Reservas
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>3.1 Reservas de Instalaciones</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          JugarHoy permite a los usuarios reservar instalaciones deportivas a través de la aplicación. Al realizar una reserva, usted acepta:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Proporcionar información precisa y actualizada
          </Typography>
          <Typography component="li" variant="body1">
            Respetar los horarios de reserva establecidos
          </Typography>
          <Typography component="li" variant="body1">
            Cancelar con anticipación si no puede asistir
          </Typography>
          <Typography component="li" variant="body1">
            Cumplir con las políticas específicas de cada instalación
          </Typography>
        </Box>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          <strong>3.2 Políticas de Cancelación</strong>
        </Typography>
        
        <Typography variant="body1" paragraph>
          Las condiciones de cancelación y reembolso al Jugador son definidas por cada Club. Jugar Hoy! reembolsará el Cargo por Servicio al Club únicamente si la cancelación se realiza dentro de los <strong>3 días posteriores a la fecha en que se realizó la reserva</strong>, con independencia de la política de cancelación del Club. Pasado ese plazo, el Cargo por Servicio no será reembolsado, ya que corresponde al uso efectivo de la plataforma.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          4. Planes de Servicio y Acuerdo Comercial con Clubes y Entrenadores
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>4.1 Planes disponibles</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          Jugar Hoy! ofrece tres niveles de servicio para Clubes y Entrenadores. Los precios no incluyen IVA salvo indicación expresa:
        </Typography>

        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            <strong>BÁSICO (sin mensualidad)</strong> — Cargo por Servicio del 0,50% por reserva procesada a través de la plataforma. Incluye todos los medios de pago habilitados y soporte por email.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>PLUS ($9.999 + IVA / mes)</strong> — Incluye 50 reservas por mes sin cargo de servicio, hasta 3 clases grupales activas, pre-reservas para hasta 10 miembros verificados seleccionados, créditos adicionales para bonificar reservas, acceso a servicios adicionales de la plataforma y soporte vía ticket.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>PREMIUM ($49.999 + IVA / mes)</strong> — Sin comisiones por reserva (ilimitado), clases grupales ilimitadas, pre-reservas ilimitadas para miembros verificados, suscripciones mensuales automáticas, cobro y validación de transferencias recibidas, membresías para miembros del club, todos los medios de pago habilitados y soporte en línea 24hs.
          </Typography>
        </Box>

        <Typography variant="body1" paragraph>
          <strong>4.2 Cargo por Servicio — Responsabilidad del Club / Entrenador</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          El Cargo por Servicio de Jugar Hoy! es asumido íntegramente por el Club o Entrenador, no por el Jugador. El Club o Entrenador deberá incluir dichos costos en su propia facturación como costo total del servicio. Jugar Hoy! no es un procesador de pagos y no cobra comisiones por transacción financiera; los costos de procesamiento son gestionados directamente por cada proveedor (MercadoPago o Cucuru).
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>4.3 Facturación y Liquidación</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          Jugar Hoy! realizará la liquidación por los costos de servicio acordados de forma <strong>semanal o mensual</strong> según la preferencia del Club o Entrenador, o bien mediante el acuerdo de membresía contratado (PLUS / PREMIUM). Al cierre de cada período, Jugar Hoy! emitirá la factura correspondiente por los servicios utilizados. Para los planes PLUS y PREMIUM, el costo de membresía reemplaza o complementa el cargo por reserva según el nivel contratado.
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>4.4 Descuentos y Recargos por Medio de Pago</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          El Club puede configurar descuentos o recargos porcentuales sobre el precio base de la reserva para cada medio de pago habilitado. Estos valores son definidos libremente por el Club y se reflejan en el total abonado por el Jugador al momento de la confirmación.
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>4.5 Proveedores de Pago</strong>
        </Typography>

        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            <strong>MercadoPago</strong> — El Club deberá vincular su cuenta de MercadoPago a través del botón de vinculación disponible en la configuración de Medios de Pago. Los fondos se acreditan directamente en la cuenta del Club. El costo de transacción es gestionado por MercadoPago según el plan vigente del Club. Se aplica adicionalmente el Cargo por Servicio de Jugar Hoy! (0,50% + IVA) en el plan BÁSICO.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Cucuru</strong> — Nuestro partner Cucuru aplica un acuerdo único de 0,50% + IVA por transacción para pagos por transferencia vía alias, al que se adiciona el Cargo por Servicio de Jugar Hoy! Para habilitarlo, el Club deberá abrir una cuenta en <strong>cucuru.com</strong> y cargar sus credenciales de API en la configuración de Medios de Pago, bajo los Términos y Condiciones de Cucuru.
          </Typography>
        </Box>

        <Typography variant="body1" paragraph>
          <strong>4.6 Promoción de Lanzamiento</strong>
        </Typography>

        <Typography variant="body1" paragraph>
          Con vigencia hasta el <strong>30/09/2026</strong>, Jugar Hoy! ofrece las siguientes bonificaciones promocionales:
        </Typography>

        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            <strong>Clubes</strong> — Plan PREMIUM gratis por 6 meses desde la fecha de creación de la cuenta.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            <strong>Entrenadores</strong> — Plan PLUS gratis por 3 meses desde la fecha de creación del perfil de coach.
          </Typography>
        </Box>

        <Typography variant="body1" paragraph>
          Las promociones son intransferibles, no acumulables con otras ofertas y se aplican automáticamente al momento del alta. Jugar Hoy! se reserva el derecho de modificar o discontinuar las promociones con previo aviso.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          5. Uso Aceptable
        </Typography>
        
        <Typography variant="body1" paragraph>
          Usted se compromete a:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Usar la aplicación solo para fines legales y apropiados
          </Typography>
          <Typography component="li" variant="body1">
            No compartir información personal de otros usuarios sin su consentimiento
          </Typography>
          <Typography component="li" variant="body1">
            No intentar acceder a cuentas de otros usuarios
          </Typography>
          <Typography component="li" variant="body1">
            Reportar cualquier comportamiento inapropiado o abusivo
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          6. Propiedad Intelectual
        </Typography>
        
        <Typography variant="body1" paragraph>
          A menos que se indique lo contrario, JugarHoy y/o sus licenciantes poseen los derechos de propiedad intelectual 
          de todo el material en la aplicación JugarHoy. Todos los derechos de propiedad intelectual están reservados.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          7. Limitación de Responsabilidad
        </Typography>
        
        <Typography variant="body1" paragraph>
          En la máxima medida permitida por la ley aplicable, excluimos todas las representaciones, garantías y condiciones 
          relacionadas con nuestra aplicación y el uso de esta aplicación.
        </Typography>
        
        <Typography variant="body1" paragraph>
          Nada en esta limitación de responsabilidad:
        </Typography>
        
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1">
            Limitará o excluirá nuestra o su responsabilidad por muerte o lesiones personales resultantes de negligencia
          </Typography>
          <Typography component="li" variant="body1">
            Limitará o excluirá nuestra o su responsabilidad por fraude o representación fraudulenta
          </Typography>
          <Typography component="li" variant="body1">
            Limitará cualquiera de nuestras o sus responsabilidades de cualquier manera que no esté permitida bajo la ley aplicable
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          8. Modificaciones
        </Typography>
        
        <Typography variant="body1" paragraph>
          Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. 
          Los cambios serán efectivos inmediatamente después de su publicación en la aplicación. 
          Su uso continuado de la aplicación después de cualquier cambio constituye su aceptación de los nuevos términos.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          9. Contacto
        </Typography>
        
        <Typography variant="body1" paragraph>
          Si tiene alguna pregunta sobre estos Términos y Condiciones, puede contactarnos a través de la aplicación 
          o enviando un correo electrónico a nuestro equipo de soporte.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
          Última actualización: {new Date().toLocaleDateString('es-ES')}
        </Typography>
        </Paper>
      </Container>
      <SiteFooter />
    </div>
  );
};

export default TermsPage; 